// src/stores/cars.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

export const useCarsStore = defineStore('cars', () => {
    const cars = ref([])
    const loading = ref(false)
    const error = ref(null)
    const filters = ref({
        make: '',
        minPrice: null,
        maxPrice: null,
        minYear: null,
        maxYear: null,
        fuelType: ''
    })
    const router = useRouter()

    const fetchCars = async () => {
        try {
            loading.value = true
            error.value = null
            const response = await axios.get('/api/cars/listings', {
                params: {
                    fetch_from_api: false,
                    country: 'Belgium'
                }
            })
            cars.value = response.data.cars || []
        } catch (err) {
            error.value = err.response?.data?.detail || err.message
            cars.value = []
        } finally {
            loading.value = false
        }
    }

    const fetchCarById = async (id) => {
        try {
            loading.value = true
            error.value = null
            const response = await axios.get('/api/cars/listings', {
                params: {
                    fetch_from_api: false,
                    country: 'Belgium'
                }
            })
            const car = response.data.cars.find(c => c.id === id)
            if (!car) throw new Error('Car not found')
            return car
        } catch (err) {
            error.value = err.response?.data?.detail || err.message
            router.push('/')
            return null
        } finally {
            loading.value = false
        }
    }

    const updateFilters = (newFilters) => {
        filters.value = { ...newFilters }
    }

    const filteredCars = computed(() => {
        return cars.value.filter(car => {
            return (
                (!filters.value.make || car.make === filters.value.make) &&
                (!filters.value.minPrice || car.price >= filters.value.minPrice) &&
                (!filters.value.maxPrice || car.price <= filters.value.maxPrice) &&
                (!filters.value.minYear || car.year >= filters.value.minYear) &&
                (!filters.value.maxYear || car.year <= filters.value.maxYear) &&
                (!filters.value.fuelType || car.fuel_type === filters.value.fuelType)
            )
        })
    })

    const resetFilters = () => {
        filters.value = {
            make: '',
            minPrice: null,
            maxPrice: null,
            minYear: null,
            maxYear: null,
            fuelType: ''
        }
    }

    return {
        cars,
        loading,
        error,
        filters,
        fetchCars,
        fetchCarById,
        updateFilters,
        resetFilters,
        filteredCars
    }

})
